export const ROBINTRACK_LOGO_ALT =
  'The Robintrack logo, a cute robin with a crescent moon eye and feet above the word Robintrack';
